import Http from '../../../http';

export const actionTypes = {
  SET_SUBSCRIPTION_STATUS: 'SET_SUBSCRIPTION_STATUS',
  SET_INVOICES: 'SET_INVOICES',
};

const subscriptionStatusFetched = subscriptionStatus => ({
  type: actionTypes.SET_SUBSCRIPTION_STATUS,
  payload: subscriptionStatus,
});


const invoicesFetched = invoiceList => ({
  type: actionTypes.SET_INVOICES,
  payload: invoiceList,
});


export const fetchSubscriptionStatus = brandId => async (dispatch) => {
  if (!brandId) {
    return;
  }

  const response = await Http.get(`/brand/${brandId}/subscription/status`);
  dispatch(subscriptionStatusFetched(response));
};

export const fetchInvoices = subscriptionId => async (dispatch) => {
  const response = await Http.get(`/subscription/${subscriptionId}/invoice`);
  dispatch(invoicesFetched(response));
};

// Return the promise, so components like the Subscription modal can tap into
// failed payment attempt and change the message accordingly; but control the
// state in redux anyway, so that its always up to date.
export const payInvoice = (brandId, subscriptionId, invoiceId) => (dispatch) => {
  const refresh = () => {
    dispatch(fetchSubscriptionStatus(brandId));
    dispatch(fetchInvoices(subscriptionId));
  };

  const refreshInvoices = () => dispatch(fetchInvoices(subscriptionId));

  // Had the request succeeded or had it failed, always refresh the state of the invoices & subscription, if passed.
  const promise = Http.put(`/subscription/${subscriptionId}/invoice/${invoiceId}/pay`);
  promise.then(refresh, refreshInvoices);

  return promise;
};

